export const tw = <T>(a: T): T => a
